import { memo } from "react";
import { SearchOutlined } from "@ant-design/icons";

interface Props {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
}

const SearchBar = memo(({ value, onChange, placeholder }: Props) => (
  <div className="relative flex-1 min-w-[220px] max-w-2xxl">
    <SearchOutlined className="absolute left-3 top-1/2 -translate-y-1/2
                               text-blue-300 text-sm pointer-events-none" />

    <input
     className="w-full pl-9 pr-4 py-2.5 rounded-xl text-sm
                       border border-blue-200 bg-white text-blue-900
                       placeholder-blue-300
                       hover:border-blue-400
                       focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100
                       transition-all duration-200"
      type="text"
      value={value}
      placeholder={placeholder || "Rechercher..."}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
));

export default SearchBar;